import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Day, Itinerary } from '../itineray.model';

@Component({
  selector: 'app-rearrange-days-dialog',
  templateUrl: './rearrange-days-dialog.component.html',
  styleUrls: ['./rearrange-days-dialog.component.css']
})
export class RearrangeDaysDialogComponent {

  days: Day[];

  constructor(@Inject(MAT_DIALOG_DATA) public data: { itinerary: Itinerary }) {
    this.days = [...this.data.itinerary.days];
  }

  getOldIndex(day: Day) {
    return this.data.itinerary.days.indexOf(day);
  }

  moveTo(fromIndex: number, toIndex: number) {
    const element = this.days[fromIndex];
    this.days.splice(fromIndex, 1);
    this.days.splice(toIndex, 0, element);
  }

}
